import type { FunctionComponent, ReactElement } from 'react';

import { clearStore } from 'pixel-react';
import { Outlet } from 'react-router-dom';

export const PublicRoute: FunctionComponent = (): ReactElement => {
  clearStore();
  return <Outlet />;
};
